import moment from "moment";
import { DateTimeFormatRepository } from "consts/general";
import { when } from "util/support";
import type { Setup } from "features/setups/types";
import { BaseSetupValue, type DateTimeValue, type ISetupValue } from "../types";

export class DateTimeSetupValue extends BaseSetupValue<DateTimeValue> implements ISetupValue<DateTimeValue> {
    public static get format() {
        return DateTimeFormatRepository.Write; // ValueType.DateTime.replace('DATE:', '')
    }

    public deserialize(setupValue: Setup<string>['setupValue']): DateTimeValue {
       return moment(setupValue, DateTimeSetupValue.format);
    }

    public serialize() {
        return when(
            this.value,
            () => this.value!.format(DateTimeSetupValue.format),
            ''
        ) ;
    }
}
